/* eslint-disable no-nested-ternary */
import React from 'react';
import { ToastContentProps } from 'react-toastify';
import { Typography } from 'tfc-components';

import Icon, { IconName } from 'components/atoms/Icon';
import mapModifiers from 'utils/functions';

const CustomToastify: React.FC<ToastContentProps<{ title?: string, message: string }>> = (
  { toastProps: { type }, data: { title, message } }
) => {
  const iconName: IconName = type === 'success'
    ? 'valid'
    : type === 'warning'
      ? 'warning'
      : 'invalid';
  return (
    <div className={mapModifiers('fToastify', type)}>
      <Icon iconName={iconName} size="24" />
      <div className="fToastify_content">
        {title && <Typography.Text extendClasses="fToastify_title" fontweight="600">{title}</Typography.Text>}
        <Typography.Text extendClasses="fToastify_message" fontweight="600">{message}</Typography.Text>
      </div>
    </div>
  );
};

export default CustomToastify;
